import { Ticket, TicketGitlabRef } from 'src/app/services/asignaciones.service';

export type GitlabMrTone = 'created' | 'merged' | 'closed';

export const GITLAB_MR_TONE_LABELS: Record<GitlabMrTone, string> = {
  created: 'CREADO',
  merged: 'MERGED',
  closed: 'CLOSED',
};

const TONE_RANK: Record<GitlabMrTone, number> = {
  created: 0,
  merged: 1,
  closed: 2,
};

export function gitlabMrTone(state?: string | null): GitlabMrTone {
  const key = (state || 'opened').toLowerCase();
  if (key === 'merged') return 'merged';
  if (key === 'closed') return 'closed';
  return 'created';
}

export function primaryGitlabMergeRequest(
  ticket: Pick<Ticket, 'gitlabRefs'> | null | undefined,
): TicketGitlabRef | null {
  const mrs = (ticket?.gitlabRefs || []).filter((ref) => ref.kind === 'merge_request');
  if (!mrs.length) return null;
  return [...mrs].sort((a, b) => {
    const rankDiff = TONE_RANK[gitlabMrTone(a.state)] - TONE_RANK[gitlabMrTone(b.state)];
    if (rankDiff !== 0) return rankDiff;
    return (b.occurredAt || b.createdAt || '').localeCompare(a.occurredAt || a.createdAt || '');
  })[0];
}

export function gitlabMrTooltip(ref: TicketGitlabRef): string {
  const tone = gitlabMrTone(ref.state);
  const iid = ref.externalId ? `!${ref.externalId}` : 'MR';
  const title = ref.title?.trim();
  return title
    ? `MR ${iid} · ${GITLAB_MR_TONE_LABELS[tone]} — ${title}`
    : `MR ${iid} · ${GITLAB_MR_TONE_LABELS[tone]}`;
}
